import {
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    RedoOutlined,
    SettingOutlined
} from '@ant-design/icons';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination } from 'antd';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import viVN from 'antd/locale/vi_VN';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as customerApi from '../../../../../api/customer/customerApi';
import { getListCustomer_V2, getListCustomerRecyclebin, getListFieldsByCustomer, ICustomer, ListField } from '../../../../../api/Customer_V2/customerApi_V2';
import { getListOperatorFieldGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterV2 } from '../../../../../api/groupCustomerV2/groupCustomerV2Api';
import * as selectOptionsApi from '../../../../../api/selectOptions/selectOptionsApi';
import { filterInfoOperatoToConditions } from '../../../../../apiSync/customerGroup/customerGroupApi';
import { warning_delete } from '../../../../../components/ExportImgFigma';
import ModalDeleteManager from '../../../../../components/ModalDeleteManager';
import { NodataTable } from '../../../../../components/NoDataTable';
import { LIMIT_EXPORT_EXCEL } from '../../../../../env';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import useToast from '../../../../../hook/useToast';
import { FIELDTYPE, NO_DATA, NO_VIEW } from '../../../../../services/data';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { selectorMenu } from '../../../../../store/slices/menuSlice';
import { selectorPermission } from '../../../../../store/slices/permissionSlice';
import { CustomLoadingOverlayTable, dataPagination, exportExcel, getUserPermissions, getWidthFromHeader, renderValueAsExcel, renderValueAsJSX } from '../../../../../until';
import { initInfoOperator } from '../../../../Customers/CustomerGroup/Component/Modal/ModalAddAndEditCondition';
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone';
import '../../styles.scss';
import CustomerFeilds from './Drawer/CustomerFeilds';
import ModalCondition from './Modal/ModalCondition';
import { ICustomerFields } from '../../../../../api/salesSericeCustomer/salesSericeCustomerApi';
import ModalRestoreCustomer from '../Modal/ModalRestoreCustomer';
import { restoreCustomer, restoreGroupCustomer } from '../../../../../api/recycleCustomer/recycleCustomerApi';
import { formatNumber } from '../../../../../services/mixin';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { buildOptions } from '../../../../CustomersV2/indexV2';

ModuleRegistry.registerModules([AllCommunityModule])

export enum TYPECONDITION {
    GROUP = 0,
    CUSTOMER = 1,
}

// new filter 

export interface IDataConditionDefaulFilterList {
    search?: string;
    isCustomer?: TYPECONDITION.GROUP | TYPECONDITION.CUSTOMER
}

export const dataConditionDefaulFilterList: IDataConditionDefaulFilterList = {
    search: undefined,
    isCustomer: undefined,
};
// end


export interface IDataDefaulFilterList {
    search: string;
    filterCustomerId: number | undefined;
    businessCheck: number[];
    gender: number[];
    listWard: number[];
    listArea: string[];
    listCategoryCar: number[];
    listSourceCustomer: number[];
    listUnit: number[];
    listCode: string[];
    listPhone: string[];
    listType: number[];
    dateStart: string;
    dateEnd: string;
    title: string; // Thêm trường titleFilter
    id: number | undefined;
    idDetailFilter: number | undefined
    listProvince: number[]
}

// bộ lọc lớn
const dataDefaulFilter = {

    title: '' as string,
    id: undefined,
} as IDataDefaulFilterList

// filter cho bảng
export const dataDefaulFilterList = {
    ...dataDefaulFilter,
    age: [] as number[],
    price: [] as number[],
    search: "" as string, // Thêm trường search
    filterCustomerId: undefined as undefined | number, // Thêm trường filterCustomerId
    // listProvince: [] as number[],
    listDistrict: [] as number[],
    listWard: [] as number[],
    businessCheck: [] as number[],
    listCode: [] as string[],
    listPhone: [] as string[],
    listType: [] as number[],
    dateStart: "" as string,
    dateEnd: "" as string,
};

interface DataType {
    key: React.Key;
    stt: number;
    name: string;
    CCCD?: string;
    phone: string;
    birthday: string | undefined;
    gender: number;
    statusMarital: number;
    address?: string;
    email: string;
    province?: string;
    taxCode?: string;
    rankTitle?: string;
    profession?: string
    code?: string
    unit?: string
    permissionMenu?: customerApi.IPermissionMenu
}

export type FlattenedField = {
    id: number;
    fieldCode: string;
    fieldLabel: string;
    inputType: string;
    parentId: number;
};

const requiredFieldCodes: string[] = [];
const RecycleCustomerList: React.FC = () => {
    const location = useLocation();
    const pushToast = useToast();
    const navigator = useNavigate()
    const pushLoading = useLoading()

    const menuSlice = useSelector(selectorMenu)
    const permissionSlice = useSelector(selectorPermission)
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

    const [loadingTable, setLoadingTable] = useState(false)

    const { unitTemp, unit } = useSelector(selectorInfoUser) // đợn vị dc chọn
    // const { add, download, delete: isdelete, share } = findChildIdByUrl(menuSlice, "/customer/list")

    const { add, edit, delete: isdelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

    //#region: location restore

    const isFistRestore = useRef(false)
    const {
        firstPage,
        restorePagination, restoreDataFilterList
    } = location.state ?? {}
    //#endregion



    useEffect(() => {

        gListFieldsActive()

        const handleResize = () => {
            const baseFactor = (48 * 100) / 1440 / 100
            const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
            const newHeight = Math.round(window.innerWidth * factor)
            setRowHeight(newHeight)
        }
        handleResize()

        window.addEventListener('resize', handleResize)

        return (() => {


            setPagination({ current: 1, pageSize: 20, total: 0 })
            setselectedIdCustomer(new Set())
            window.removeEventListener('resize', handleResize)
        })
    }, [])

    const [searchListFilter, setSearchListFilter] = useState<string>('')

    // lọc đk
    const [dataConditionFilter, setDataConditionFilter] = useState<IDataConditionDefaulFilterList>(dataConditionDefaulFilterList)

    const [isModalCondition, setModalCondition] = useState<boolean>(false)

    const [infoOperator, setInfoOperator] = useState<IVConditionFilterV2>(initInfoOperator)
    const [sLOperatorFieldGroup, setSLOperatorFieldGroup] = useState<IOperatorFieldGroupV2[]>([])
    const [sLListFilter, setSLListFilter] = useState<selectOptionsApi.ISelectOption[]>([])

    // HANDLE MODAL
    //Bộ lọc
    const [isModalFilterList, setIsModalFilterList] = useState(false);


    const [isSettingShow, setSettingShow] = useState(false)

    const [openDeleteListCustomer, setOpenDeleteListCustomer] = useState(false)
    const [openRestoreCustomer, setOpenRestoreCustomer] = useState(false)



    const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

    const [selectedIdCustomer, setselectedIdCustomer] = useState<Set<number>>(new Set());
    const [idCustomer, setIdCustomer] = useState<number | number[]>();



    //lọc ds bộ lọc
    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

    // Logic table mới
    const [rowHeight, setRowHeight] = useState(40)
    const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
    const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
    const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

    const [customerList, setcustomerList] = useState<ICustomer[]>([])

    //Kh có dk--------------------
    const [infoCondFilterSync, setInfoCondFilterSync] =
        useState<{ matched: number[], unMatched: number[] }>({
            matched:
                [24, 17, 8, 10, 46, 43, 28, 27, 48, 32, 4, 19, 54, 26],
            unMatched: [
                1304, 1686, 2030, 1684, 2036, 3411, 2033, 1697, 1696, 5491, 1694, 9, 857, 1701, 862,
                1691, 2035, 2037, 35, 55, 2032, 16, 1690, 1693, 3, 58, 1699, 3313, 1303, 1703, 49, 1,
                2041, 6, 1687, 1707, 2031, 1695, 1692, 2034, 40, 33, 12, 1688, 18, 21, 51, 15, 29,
                856, 860, 2027, 1689, 1698, 864, 1709, 22, 859, 5, 861, 57, 3314, 2042, 39, 44,
                53, 2040, 2044, 2039, 863, 1708, 1705, 1704, 2029, 37, 1700, 31, 41, 2028, 855,
                962, 60, 50, 2043, 1685, 1706, 1702, 36, 2038, 7, 30, 858
            ]
        });


    //Kh có dk--------------------
    //#region  cột
    const generateColumnsFromCodesAgGridReact = (
        codes: ColumnKey[],
        fields: ICustomerFields[],
        dataFilterList: IDataDefaulFilterList,
        actionColumn?: ColDef<any, any>,
        // headerActions: HeaderActions = { setDataFilterList: NOOP }
    ): ColDef[] => {
        const baseColumns = codes
            ?.map(code => {
                const field = fields.find(f => f.fieldCode === code)
                if (!field) return null
                // const headerExtras: FilterHeaderExtras = {
                //     dataFilterList,
                //     setDataFilterList: headerActions.setDataFilterList,
                // }

                return {
                    headerName: field.fieldLabel,
                    // headerComponent: FilterHeader,
                    // headerComponentParams: headerExtras, // chỉ extras
                    field: field.fieldCode,
                    colId: field.fieldCode,
                    sortable: true,
                    maxWidth: 1000,
                    width: getWidthFromHeader(field.fieldLabel),
                    cellRenderer: (params: any) => renderValueAsJSX(params.value, field.fieldCode)
                } as ColDef
            })
            .filter(Boolean) as ColDef[]

        return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
    }

    const actionColumn: ColDef = {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 180,
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
        headerComponentParams: {
            template: '<span class="w-full flex items-center justify-center">Hành động</span>'
        },
        cellRenderer: (params: any) => {
            const idCustomer = params.data.id
            const { view, edit, delete: isDelete } = params?.data?.permissionMenu
            return (
                <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!edit && "disabled"}`}
                        onClick={() => navigator(
                            `/customer/list/edit`,
                            {
                                state: {
                                    firstPage: "/customer/recyclebin",
                                    id: idCustomer,
                                    isEdit: false,
                                    restorePagination: pagination,
                                    restoreDataFilterList: dataFilterList
                                }
                            }
                        )}
                    />
                    <DeleteOutlined
                        className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${!isDelete && "disabled"}`}
                        onClick={() => openModalDeleteListCustomer([Number(idCustomer)])}
                    />
                </div>

            )
        },
    }


    // #endregion kết thúc cột
    const tableData: ICustomer[] = useMemo(() => {
        return customerList.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})

            Object.entries(requiredFieldCodes).forEach(([fieldCode, defaultValue]) => {
                if (!(fieldCode in fieldValues)) {
                    fieldValues[fieldCode] = defaultValue
                }
            })

            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [customerList])

    const memoizedColumnDefs = useMemo(() => {
        if (ColumnsMapShow.length)
            return generateColumnsFromCodesAgGridReact(
                ColumnsMapShow, dataFilterActive, dataFilterList,
                actionColumn,
            );
    }, [ColumnsMapShow, dataFilterActive, dataFilterList, pagination]);

    // filter KH
    const gSLlistFilter = useDebounce(async () => {
        const {
            search, isCustomer = TYPECONDITION.CUSTOMER,
        } = dataConditionFilter
        const result = await selectOptionsApi.getSLlistFilter(search, isCustomer)
        if (result?.status) {
            setSLListFilter(result?.data)
        }
    }, 1000)

    const gInfoFilter = useDebounce(async (value: number) => {
        setModalCondition(true)
        setDataFilterList({ ...dataFilterList, idDetailFilter: value })
    }, 200)


    const gListOperatorFieldGroup = useDebounce(async () => {
        pushLoading(true)
        const result = await getListOperatorFieldGroup(searchListFilter
        )
        if (result?.status) {
            setSLOperatorFieldGroup(result.data)
        }
        pushLoading(false)
    }, 1000)

    // hàm xử lý select trường V2
    const options = useMemo(() => buildOptions(sLOperatorFieldGroup), [sLOperatorFieldGroup]);

    const selectableOptions = options.filter(
        (item) => !item.isGroup
    );
    // end

    const gListFieldsActive = async () => {
        pushLoading(true)
        const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1)
        if (result?.status) {
            const flattenedFields = result.data.flatMap(choice =>
                choice.fields.map(field => ({
                    ...field,
                    parentId: choice.id,
                }))
            );
            setDataFilterActive(flattenedFields)
            gListFieldsNotActive()
        }
        pushLoading(false)
    }

    const gListFieldsNotActive = async () => {
        const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 0)
        if (result?.status) {
            setDataFilterNoActive(result.data)
        }
    }
    const gListCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        setLoadingTable(true)
        const pageCurentTmp = isFistRestore.current ? restorePagination.current : pageCurent
        const pageSizeTmp = isFistRestore.current ? restorePagination.pageSize : pageSize

        const { search } = dataFilterList

        const unitId = unitTemp ? unitTemp : undefined

        const conditions = filterInfoOperatoToConditions(infoOperator)

        const result = await getListCustomerRecyclebin(
            pageSizeTmp, pageCurentTmp, search,
            unitId
        )
        if (result?.status) {
            isFistRestore.current = false

            setcustomerList(result.data)
            // console.log(result.data)
            setPagination({ current: pageCurentTmp, total: result.total, pageSize: pageSizeTmp })
        } else {
            pushToast(result?.message, "warning")
        }
        setLoadingTable(false)
    }, 1000)

    //Bộ lọc ds khách hàng
    const onChangeFilterListName = (value: string) => {
        setDataFilterList({ ...dataFilterList, search: value })
    }

    const onChangeFilterListF = (value: number) => {
        setIsModalFilterList(false)
        setDataFilterList({ ...dataDefaulFilterList, filterCustomerId: value })
    }

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
        gListCustomer(pageNumber, pageSize)
    }

    const { Search } = Input;

    // modal điều kiện
    const setActiveAddFilter = () => {
        setModalCondition(true)
    };

    const onSubmitFormModalSaveFilter = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            gSLlistFilter()
            setModalCondition(false)
            pushToast(message, "success")

        }
        else {
            pushToast(message, "warning")
        }
    }

    const handleClearFilter = () => {
        if (dataFilterList.filterCustomerId) {
            setDataFilterList({ ...dataFilterList, filterCustomerId: undefined })
            gListCustomer()
        }
        setIsModalFilterList(false)
    }

    // filter KH
    const onConfirmDeleteFilter = async (id: number) => {
        pushLoading(true)
        const result = await selectOptionsApi.deleteFilter(id)

        if (result?.status) {
            pushToast(result.message, "success")
            gSLlistFilter()
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }

    const openModalDeleteListCustomer = (id: number[]) => {
        setIdCustomer(id)
        setOpenDeleteListCustomer(true)
    }

    const openModalRestoreListCustomer = (id: number[]) => {
        // console.log(id)
        setIdCustomer(id)
        setOpenRestoreCustomer(true)
    }

    const closeModalDelete = () => {
        setIdCustomer(undefined)
        setOpenDeleteListCustomer(false)
    }

    const closeModalRestore = () => {
        setIdCustomer(undefined)
        setOpenRestoreCustomer(false)
    }

    const onConfirmDelete = async () => {
        const result = await customerApi.deleteCustomer(idCustomer)
        if (result?.status) {
            pushToast(result.message, "success")
            closeModalDelete()
            setselectedIdCustomer(new Set())
            gListCustomer(pagination.current, pagination.pageSize)
        } else {
            pushToast(result?.message, "warning")
        }
    }

    const onConfirmRestore = async () => {
        if (idCustomer !== undefined) {
            const id = Array.isArray(idCustomer) ? idCustomer : [idCustomer]
            const result = await restoreCustomer(id)
            if (result?.status) {
                pushToast(result.message, "success")
                closeModalRestore()
                setselectedIdCustomer(new Set())
                gListCustomer(pagination.current, pagination.pageSize)
            } else {
                pushToast(result?.message, "warning")
            }
        }


    }

    //XUAT EXEL TẤT CẢ DANH SÁCH -------
    const glistByExcel = useThrottle(async () => {
        // pushLoading(true)
        // let listFieldByRerordAll: selectOptionsApi.IFieldByRerordAll[] = []
        // let listCustomerAll: ICustomer[] = []
        // let listCustomerSelectTmp: ICustomer[] = []

        // const result = await selectOptionsApi.getSLFieldByRerordAll(FIELDTYPE.CUSTOMER)
        // if (result?.status) {
        //     listFieldByRerordAll = result.data
        // } else {
        //     pushToast(result?.message, "warning")
        //     pushLoading(false)
        //     return
        // }

        // const {
        //     filterCustomerId, gender, listArea, listWard,
        //     listCategoryCar, search, listSourceCustomer, listUnit, businessCheck,
        //     listCode, listPhone, listType, dateStart, dateEnd,
        //     listProvince
        // } = dataFilterList

        // const conditions = filterInfoOperatoToConditions(infoOperator)


        // if (!selectedIdCustomer.size) {
        //     const resultList = await getListCustomer_V2(
        //         permittedCategoryCarIds,
        //         LIMIT_EXPORT_EXCEL, 1, search, undefined,
        //         undefined, unitTemp, filterCustomerId,
        //         businessCheck, undefined, undefined, gender,
        //         undefined, listProvince, listWard,
        //         undefined, undefined, undefined, undefined,
        //         listCategoryCar, undefined, undefined, undefined,
        //         undefined, listUnit, undefined, undefined,
        //         undefined, undefined, undefined,
        //         undefined, listPhone, listType, listCode,
        //         undefined, undefined, dateStart, dateEnd,
        //         conditions
        //     )
        //     if (resultList?.status) {
        //         listCustomerAll = resultList.data
        //     } else {
        //         pushToast(resultList?.message, "warning")
        //         pushLoading(false)
        //         return
        //     }
        // } else {

        //     listCustomerSelectTmp = tableData.filter(item => selectedIdCustomer.has(item.id));
        // }

        // // xuat exel theo trường tùy chọn, new arr [] => xuât all
        // var listCustomerExport = selectedIdCustomer.size ? listCustomerSelectTmp : listCustomerAll
        // const data = listCustomerExport.map(customer =>
        //     listFieldByRerordAll.reduce((acc, field) => {
        //         const matched = customer.fields.find(f => f.fieldCode === field.fieldCode);
        //         acc[field.fieldLabel] = renderValueAsExcel(matched?.value);
        //         return acc;
        //     }, {} as Record<string, any>)
        // );
        // exportExcel(data, 'Danh sách khách hàng')
        // pushLoading(false)

    }, 1000)
    //XUAT EXEL TẤT CẢ DANH SÁCH END -----------

    const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
        if (iSsuccess) {
            setSettingShow(false)
            pushToast(message, "success")
            setDataFilterActive(dataFilterActive ?? [])
            setDataFilterNoActive(dataFilterNoActive ?? [])
            gListCustomer()

        } else {
            pushToast(message, "warning")
        }
    }

    const onCloseDataFields = () => {
        setSettingShow(false)
    }

    // Trong Ag-Grid, thêm onSelectionChanged
    const onSelectionChanged = (event: any) => {
        const selectedNodes = event.api.getSelectedNodes();
        const selectedIds = new Set<number>(
            selectedNodes.map((node: any) => Number(node.data.id))
        );
        setselectedIdCustomer(selectedIds);
    };


    useEffect(() => {
        gSLlistFilter()
    }, [dataConditionFilter])


    useEffect(() => {
        gListOperatorFieldGroup()
    }, [searchListFilter])
    // modal dk
    useEffect(() => {
        if (!sLOperatorFieldGroup.length && isModalCondition)
            gListOperatorFieldGroup()
    }, [isModalCondition])

    useEffect(() => {
        gListCustomer()
    }, [dataFilterList, unitTemp])

    useEffect(() => {
        const codes = dataFilterActive.map(f => f.fieldCode)
        setColumnsMapShow(codes)
    }, [dataFilterActive])

    //#region: location restore useEffect
    useEffect(() => {
        if (/\/customer\/list\/\d+/.test(firstPage)) {
            // console.log(location.state);
            if (restoreDataFilterList) {
                setDataFilterList(restoreDataFilterList)
            }

            if (restorePagination) {
                isFistRestore.current = true
                gListCustomer(restorePagination.current, restorePagination.pageSize)
            }
        }
    }, [location.state])
    //#endregion

    return (
        <Fragment>
            <ModalCondition
                isOpen={isModalCondition}
                selectableOptions={selectableOptions}
                options={options}
                sLListFilter={sLListFilter}

                dataFilterList={dataFilterList}
                infoOperator={infoOperator}
                infoCondFilterSync={infoCondFilterSync}

                setIsModalFilterList={setIsModalFilterList}
                setDataFilterList={setDataFilterList}
                setInfoOperator={setInfoOperator}
                setInfoCondFilterSync={setInfoCondFilterSync}
                setSearchListFilter={setSearchListFilter}

                onSubmitFormModal={onSubmitFormModalSaveFilter}
                closeModal={setModalCondition}
            />

            <ModalDeleteManager
                isOpen={openDeleteListCustomer}
                title="Bạn có chắc chắn xóa khách hàng này"
                titleDelete="Xóa khách hàng"
                content="Bạn có chắc chắn muốn xóa vĩnh viễn khách hàng đã chọn?"
                closeModal={closeModalDelete}
                onConfirm={onConfirmDelete}
            />
            <ModalRestoreCustomer
                isOpen={openRestoreCustomer}
                title="Bạn có chắc chắn khôi phục khách hàng?"
                titleDelete="Khôi phục"
                content="Bạn có muốn khôi phục khách hàng đã chọn?"
                closeModal={closeModalRestore}
                onConfirm={onConfirmRestore}
            />
            {
                isSettingShow ?
                    <CustomerFeilds
                        isSettingShow={isSettingShow}
                        dataFilterActive={dataFilterActive}
                        dataFilterNoActive={dataFilterNoActive}

                        onSaveDataFields={onSaveDataFields}
                        onClose={onCloseDataFields}
                    /> :
                    null
            }
            <div className='customer-list custom-page-css h-full flex flex-col justify-between'>
                <div className="">
                    <div className="custom-page-css w-full flex items-center justify-between mb-4 filter-block">
                        <div className='t-search-block-v1'>
                            <Search
                                placeholder="Tìm kiếm thông tin khách hàng"
                                value={dataFilterList.search}
                                onChange={(e) => onChangeFilterListName(e.target.value)}
                            />
                        </div>
                        <div className="btn-input t-px-8" onClick={() => setSettingShow(true)}>
                            <div className="icon-svg">
                                <SettingOutlined />
                            </div>
                        </div>
                    </div>
                    <div className="custom-page-css w-full flex items-center gap-2 mb-4 ">
                        <img src={warning_delete} alt="" />
                        <span className='custom-page-css text-base text-FA8C16'>Hệ thống sẽ tự động xóa bản ghi vĩnh viễn sau 30 ngày nếu không được khôi phục</span>
                    </div>
                    {
                        selectedIdCustomer.size > 0 && (
                            //  Fillter block
                            <div className={`filter-block filter-active-show active`}>
                                <div className='total-chosse'>
                                    {`Đã chọn ${selectedIdCustomer.size} khách hàng`}
                                </div>
                                <div
                                    className="btn-input"
                                    // onClick={glistByExcel}
                                    onClick={() => openModalRestoreListCustomer(Array.from(selectedIdCustomer))}
                                >
                                    <div className="icon-svg">
                                        <RedoOutlined />
                                    </div>
                                    <div className="text">Khôi phục khách hàng </div>
                                </div>

                            </div>
                        )
                    }
                    < div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
                        <div className="ag-theme-alpine custom-table-ag custom-css-table"
                            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
                        >
                            <AgGridReact
                                className="my-auto-height-grid"
                                getRowStyle={(params: any) => ({
                                    backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                                })}
                                rowData={tableData}
                                columnDefs={memoizedColumnDefs}
                                rowHeight={rowHeight}
                                rowSelection={{ mode: 'multiRow' }}
                                overlayNoRowsTemplate={NodataTable}
                                loading={loadingTable}
                                loadingOverlayComponent={CustomLoadingOverlayTable}
                                onSelectionChanged={onSelectionChanged}
                                // Performance optimizations
                                suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
                                suppressRowVirtualisation={false} // Giữ row virtualization
                                enableCellTextSelection={true}
                                ensureDomOrder={true}
                                debounceVerticalScrollbar={true}
                                suppressScrollOnNewData={true}
                                suppressDragLeaveHidesColumns={true}

                                // Thêm các props sau để cải thiện scroll
                                rowBuffer={20}
                                maxBlocksInCache={10}
                                infiniteInitialRowCount={1000}
                            />

                        </div>

                        {/* </> */}
                    </div>
                </div>
                <div className="custom-page-css w-full flex justify-center mt-auto">
                    <ConfigProvider locale={viVN} >
                        <div className="pagination-block">
                            <Pagination
                                className='rs-pagination'
                                showSizeChanger
                                current={pagination.current}
                                pageSize={pagination.pageSize}
                                total={pagination.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                onChange={onPaginationChange}
                            />
                        </div>
                    </ConfigProvider>
                </div>
            </div >
        </Fragment >
    )
}

export default RecycleCustomerList
